// extracted by mini-css-extract-plugin
module.exports = {"trustpilot-widget-container":"trustpilot-widget_trustpilot-widget-container__5_bmN"};